module.exports = __webpack_public_path__ + "static/media/joshua.924a4b32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/joshua.png
// module id = 1158
// module chunks = 0